// extracted by mini-css-extract-plugin
export default {"pageList":"PageList_pageList__Spv7T","card":"PageList_card__fEwxq","popIn":"PageList_popIn__XGwz8","cardContent":"PageList_cardContent__vfpw4"};